module.exports = __webpack_public_path__ + "fonts/comfortaa-v27-latin-regular.9e98d45d.ttf";